import React from 'react';
import VHS_Door from '../Assets/VHS_Door.svg';
import VHS_Tape from '../Assets/VHS_Tape.svg';

const Tape = (props) => {

      let asset;

      function DoorListener(action) {
        props.onStateChange( action );
      }
  
      if(props.showTape){
        asset = VHS_Tape;
      } else {
        asset = VHS_Door;
      }

      return(
          <div className="Tape" action='tape_in' onClick={ DoorListener.bind(this, 'tape_in') }>
            <img src={asset} alt=""/>
          </div>
        );
    }

export default Tape; 


// WEBPACK FOOTER //
// ./src/Tape/Tape.js